import { httpClient } from './httpClient'

export interface HealthReport {
  status: string
  totalDurationMs: number
  checks: Array<{
    name: string
    status: string
    description?: string
    durationMs: number
  }>
}

/** System/diagnostics endpoints used to verify backend connectivity. */
export const systemApi = {
  async ready(): Promise<HealthReport> {
    const { data } = await httpClient.get<HealthReport>('/health/ready')
    return data
  }
}
